import React from 'react';
import styled from 'styled-components';
import {FormikWeekPicker} from './FormikWeekPicker';
import {RawWeekpicker} from './RawWeekpicker';

export function WeekPicker({raw, ...props}) {
    if (raw) {
        return <RawWeekpicker {...props} />;
    } else {
        return (
            <Wrapper>
                <FormikWeekPicker {...props} />
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`

.react-datepicker__week:hover {
    .react-datepicker__day {
        border-radius: 3px;
        color: var(--datepicker-select-text-hover);
        font-weight: 500;
        background-color: var(--datepicker-select-background-hover);
    }
`;
